import { TransportState } from './states/transport-device.state';
import { TrainState } from './states/train-device.state';

export const transportsStates = [TransportState, TrainState];
